<template>
  <div class="qr-code-container">
    <!-- Primeira camada: div externa com background branco -->
    <div class="qr-code-outer-wrapper">
      <!-- Segunda camada: div interna com background e borda branca -->
      <div class="qr-code-wrapper">
        <!-- Terceira camada: div com SVG de fundo branco -->
        <div class="white-background">
          <!-- Quarta camada: imagem branca de fundo como base64 para compatibilidade total -->
          <div class="white-bg-base64"></div>
          <!-- Quinta camada: imagem branca de fundo como arquivo -->
          <img src="../assets/white-square.svg" class="white-bg-image" alt="" />
          <!-- Sexta camada: o QR code com fundo branco -->
          <qrcode-vue
            :value="value"
            :size="size"
            :level="level"
            :margin="margin"
            bg-color="white"
            :background="'#FFFFFF'"
            class="qrcode-element"
          ></qrcode-vue>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'QrCodeWhite',
  components: {
    QrcodeVue
  },
  props: {
    value: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 200
    },
    level: {
      type: String,
      default: 'H'
    },
    margin: {
      type: Number,
      default: 16
    }
  }
}
</script>

<style scoped>
.qr-code-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
}

.qr-code-outer-wrapper {
  background-color: white;
  padding: 4px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
}

.qr-code-wrapper {
  background-color: white !important;
  padding: 4px;
  border-radius: 8px;
  border: 2px solid white;
  display: inline-block;
  position: relative;
}

.white-background {
  background-color: white !important;
  background-image: url('../assets/qr-background-white.svg');
  background-size: cover;
  background-repeat: no-repeat;
  border: 6px solid white;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  
  /* Essas propriedades CSS ajudam a forçar o fundo branco mesmo em modo escuro */
  color-scheme: light;
  forced-color-adjust: none;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

/* Adiciona um pseudo-elemento branco para garantir o fundo branco */
.white-background::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  z-index: 0;
}

/* Base64 image de um quadrado branco para compatibilidade total */
.white-bg-base64 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=');
  background-repeat: repeat;
  background-color: white;
  z-index: 1;
}

.white-bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.qrcode-element {
  position: relative;
  z-index: 3;
  background-color: white !important;
}
</style> 